import { jsx as t, jsxs as l, Fragment as N } from "react/jsx-runtime";
import { createContext as Y, useContext as S, useState as j, useMemo as se, useEffect as O } from "react";
import { initReactI18next as ve, useTranslation as x, Trans as A, I18nextProvider as be } from "react-i18next";
import { useIVASetChatStatus as _e } from "iva-react-web-ui";
import { useAccountSummaryV2Query as ke } from "@syf-api-library/account-summary";
import { useProfileQuery as Ie } from "@syf-api-library/profile";
import { useShippingStatusQuery as $e } from "@syf-api-library/shipping-status";
import { useQueryClient as Oe } from "@tanstack/react-query";
import { createInstance as Le } from "i18next";
import Ne from "i18next-browser-languagedetector";
import { SlideInModalPortal as Pe, ModalHeader as we } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { ModalFooter as Me } from "syf-component-library/ui/patterns/SlideInModal";
import o from "styled-components";
import h from "syf-component-library/const/mediaQueries";
import { colors as u, fontWeights as f, lineHeights as B, fontSizes as E, spacing as s, statusColors as Be } from "syf-component-library/defaultTheme";
import { FontAwesomeIcon as ce } from "@fortawesome/react-fontawesome";
import { Tag as Ue, Small as de, SyfLoader as Fe } from "syf-component-library/ui";
import { Inset as ze, Stack as _ } from "syf-component-library/ui/spacing";
import { formatDisplayDateWithFormat as le } from "syf-js-utilities";
import { faCheck as Ve, faCircleChevronDown as je } from "@fortawesome/pro-regular-svg-icons";
import Ke from "syf-component-library/ui/typography/Small";
import pe from "syf-component-library/ui/atoms/Button/Button";
import Ge from "syf-component-library/ui/typography/H5";
import Ye from "syf-component-library/ui/atoms/Collapse/Collapse";
const We = { BuildVersion: "1.0.4" }, k = Y({
  selectedAccountId: "",
  triggerAnalyticsEvent: () => {
  },
  lostOrStolenMfeHandler: () => {
  }
}), ue = () => S(k), D = "clicktrackingevent", W = "button", L = "link", qe = "expand", He = "collapse", Qe = "x button", ge = "close", K = "online chat", Je = "view more", Xe = "show less", Ze = "Activate my card", et = "report your card as never received", tt = "Online chat: order support", C = { CARD_STATUS_TRACKER: "card status tracker" }, rt = "multi-cards", at = "single-card", U = {
  NO_REPLACEMENT: "no replacement",
  API_FAILURE: "api failure",
  REPLACEMENT_IN_PROGRESS: "replacement in progress"
}, y = {
  CARD_REQUESTED: "card requested",
  CARD_SHIPPED: "card shipped",
  CARD_IN_TRANSIT: "card in transit",
  ERROR: "error",
  OUT_FOR_DELIVERY: "out for delivery",
  REQUEST: "request",
  VIEW: "view"
}, F = {
  BUSINESS_ERROR: "If you recently requested a card, please allow at least two business days for tracking information to be reflected.",
  TRY_AGAIN: "Please try again later or reach out to us using Online Chat",
  TRACKING: "For tracking help, please reach out using Online Chat.",
  REPLACEMENT_ERROR: "If you need more help, please contact us using Online Chat"
}, z = {
  NO_CARD: "We didn’t find any card requests",
  API_FAILURE: "We’re having trouble retrieving your information",
  REPLACEMENT_REQUEST_ERROR: "replacement currently processing"
}, M = (e) => !e || e === 0 ? { pageFunction: "" } : e > 1 ? { pageFunction: rt } : { pageFunction: at }, I = {
  cardStatusTracker: {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.VIEW
  },
  "CARD ORDERED": {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.CARD_REQUESTED
  },
  "PREPARING FOR SHIPMENT": {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.CARD_SHIPPED
  },
  "IN TRANSIT": {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.CARD_IN_TRANSIT
  },
  "OUT FOR DELIVERY": {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.OUT_FOR_DELIVERY
  },
  no_card_error: {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.REQUEST,
    pageSubFunction: U.NO_REPLACEMENT,
    errorMessage: z.NO_CARD,
    message: F.BUSINESS_ERROR
  },
  replacement_request_error: {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.VIEW,
    pageSubFunction: U.REPLACEMENT_IN_PROGRESS,
    errorMessage: z.REPLACEMENT_REQUEST_ERROR,
    message: F.REPLACEMENT_ERROR
  },
  api_failure_error: {
    pageKind: C.CARD_STATUS_TRACKER,
    pageName: y.ERROR,
    message: F.TRY_AGAIN,
    errorMessage: z.API_FAILURE,
    pageSubFunction: U.API_FAILURE
  }
}, nt = (e) => e ? {
  "data-object": He,
  "data-type": Xe
} : {
  "data-object": qe,
  "data-type": Je
}, q = Y(void 0), ot = q.Provider, me = () => {
  const e = S(q);
  if (!e)
    throw new Error("No config");
  return e;
}, H = (e, r) => {
  const n = S(q), i = Oe();
  if (!n)
    throw new Error("No config");
  return {
    config: n,
    queryOptions: {
      ...i.getQueryDefaults(),
      enabled: e,
      ...r
    }
  };
}, Q = (e = !0) => {
  const { selectedAccountId: r } = S(k), n = H(e);
  return $e({
    keyProps: {
      accountId: r,
      /**
       * This type is needed since account numbers are encoded as guid from the accounts api and
       * api needs the type in order to convert them to usable account numbers
       */
      accountIdType: "guid"
      /*
       * I am not sure where to get this from
       * paymentInstrumentReferenceId
       */
    },
    ...n
  });
}, he = (e = !0) => {
  const { selectedAccountId: r } = S(k), n = H(e);
  return Ie({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...n
  });
}, J = (e = !0) => {
  const { selectedAccountId: r } = S(k), n = H(e);
  return ke({
    keyProps: {
      accountId: r,
      /**
       * This type is needed since account numbers are encoded as guid from the accounts api and
       * account summary api needs the type in order to convert them to usable account numbers
       */
      accountIdType: "guid"
    },
    ...n
  });
}, it = {
  cardStatusTracker: ["error"],
  error: [],
  initializing: ["cardStatusTracker", "error"]
}, st = {
  isModalOpen: !1,
  handleModalClose: () => {
  },
  transition: () => {
  },
  handleChatOpen: () => {
  },
  handleActivateCard: () => {
  },
  metaData: {}
}, fe = Y(st), ct = ({ children: e, handleModalClose: r, isModalOpen: n }) => {
  const [i, a] = j(void 0), [c, p] = j({}), { selectedAccountId: d, triggerAnalyticsEvent: T } = S(k), { pointOfNeedChat: m } = _e(), { data: P } = Q(), w = se(() => ({
    activeScreen: i,
    isModalOpen: n,
    metaData: c,
    transition: (R, b = {}) => {
      i && !it[i].includes(R) ? console.error(`
          Invalid transition from ${i} to ${R}`) : (a(R), p(b), I[R] !== void 0 && T({
        ...I[R],
        ...M(P?.cards.length)
      }), b && b.errorType && I[b.errorType] !== void 0 && T({
        ...I[b.errorType],
        ...M(P?.cards.length)
      }));
    },
    handleModalClose: () => {
      a(void 0), p({}), r();
    },
    handleChatOpen: () => {
      m("CST", d);
    },
    handleActivateCard: () => {
      m("AC", d);
    }
  }), [
    i,
    r,
    n,
    c,
    m,
    d
  ]);
  return /* @__PURE__ */ t(fe.Provider, { value: w, children: e });
}, v = () => S(fe), dt = {
  mfeTitle: "Track your card",
  button: {
    closeButtonText: "CLOSE",
    activateCard: "Activate My Card"
  },
  header: {
    subheading: "If you need more help, please contact us using <chatLink>Online Chat</chatLink>."
  },
  apiError: {
    errorTitle: "We're having trouble retrieving your information",
    errorDescription: "Please try again later or reach out to us using <chatLink>Online Chat</chatLink>."
  },
  noReplacementRequest: {
    errorTitle: "We didn't find any card requests",
    errorSecondaryDescription: "If you recently requested a card, please allow at least two business days for tracking information to be reflected.",
    errorDescription: "Please contact us using <chatLink>Online Chat</chatLink> if you need help."
  },
  stepper: {
    "CARD ORDERED": "Card Requested",
    "PREPARING FOR SHIPMENT": "Card Shipped",
    "IN TRANSIT": "In Transit",
    "OUT FOR DELIVERY": "Out for Delivery",
    DELIVERED: "Delivered",
    lostStolenNote: "If you do not receive your card within 2 business days of the date provided, <lostStolenButton>please report your card as never received</lostStolenButton> so we can issue you a new card. Please contact us using <chatLink>Online Chat</chatLink> if you need help.",
    deliveryAddress: "Delivery Address",
    deliveredBy: "Delivered by {{shipmentCarrier}}",
    estimatedDelivery: "Estimated Delivery: ",
    viewMore: "View More",
    showLess: "Show Less",
    readyToUse: "Got your card? Let’s make sure it’s ready to use.",
    card: "CARD"
  },
  chip: {
    "CARD ORDERED": "Card Requested",
    "PREPARING FOR SHIPMENT": "Card Shipped",
    "IN TRANSIT": "In Transit",
    "OUT FOR DELIVERY": "Out for Delivery",
    DELIVERED: "Delivered"
  },
  error: {
    pending: "Pending",
    message: "We're currently processing your previous request to replace this card. Check back later for updates."
  },
  noCardUpdate: {
    errorTitle: "Replacement currently processing",
    errorDescription: "We're currently processing your previous request to replace this card.<br>Check back later for updates. If you need more help, please contact us using <chatLink>Online Chat</chatLink>."
  }
}, lt = {
  mfeTitle: "Rastree su tarjeta",
  button: {
    closeButtonText: "CERRAR",
    activateCard: "Activar Mi Tarjeta"
  },
  header: {
    subheading: "Si necesita más ayuda, comuníquese con nosotros por medio de <chatLink>Chat en Línea</chatLink>."
  },
  apiError: {
    errorTitle: "Tenemos problemas para recuperar su información",
    errorDescription: "Por favor, vuelva a intentarlo más tarde, o comuníquese con nosotros por medio de <chatLink>Chat en Línea</chatLink>."
  },
  noReplacementRequest: {
    errorTitle: "No encontramos ninguna solicitud de tarjeta",
    errorSecondaryDescription: "Si recientemente solicitó una tarjeta, por favor espere al menos dos días hábiles para que la información de rastreo se refleje.",
    errorDescription: "Comuníquese con nosotros usando el <chatLink>Chat en Línea</chatLink> si necesita ayuda."
  },
  stepper: {
    "CARD ORDERED": "Tarjeta Solicitada",
    "PREPARING FOR SHIPMENT": "Tarjeta Enviada",
    "IN TRANSIT": "En Tránsito",
    "OUT FOR DELIVERY": "Salió para Entrega",
    DELIVERED: "Entregada",
    lostStolenNote: "Si no recibe su tarjeta en un plazo de 2 días hábiles a partir de la fecha indicada, por favor, <lostStolenButton>reporte su tarjeta como no recibida</lostStolenButton> para que podamos emitirle una nueva. Si necesita ayuda, contáctenos por medio de <chatLink>Chat en Línea</chatLink>.",
    deliveryAddress: "Dirección de Entrega",
    deliveredBy: "Entregada por {{shipmentCarrier}}",
    estimatedDelivery: "Entrega Estimada: ",
    viewMore: "Ver Más",
    showLess: "Mostrar Menos",
    readyToUse: "¿Recibió su tarjeta? Asegurémonos de que está lista para usar.",
    card: "TARJETA"
  },
  chip: {
    "CARD ORDERED": "Tarjeta Solicitada",
    "PREPARING FOR SHIPMENT": "Tarjeta Enviada",
    "IN TRANSIT": "En Tránsito",
    "OUT FOR DELIVERY": "Salió para Entrega",
    DELIVERED: "Entregada"
  },
  error: {
    pending: "Pendiente",
    message: "Actualmente, estamos procesando su solicitud anterior para reemplazar esta tarjeta. Vuelva más tarde para consultar si hay actualizaciones."
  },
  noCardUpdate: {
    errorTitle: "Actualmente se está procesando el reemplazo",
    errorDescription: "Actualmente, estamos procesando su solicitud anterior para reemplazar esta tarjeta.<br>Vuelva más tarde para consultar si hay actualizaciones. Si necesita más ayuda, comuníquese con nosotros por medio de <chatLink>Chat en Línea.</chatLink>"
  }
}, g = "CardStatusTracker", pt = {
  en: {
    [g]: dt
  },
  es: {
    [g]: lt
  }
}, G = Le({
  debug: !1,
  fallbackLng: "en",
  interpolation: { escapeValue: !1 },
  resources: pt,
  defaultNS: g
});
G.use(new Ne(null, { lookupLocalStorage: "language" })).use(ve).init();
const ut = o.div`
  position: absolute;
  width: 100%;
  bottom: 0;

  @media ${h.lessThanSmall} {
    .footer {
      min-height: auto;
      padding: 16px;

      button {
        margin-bottom: 0;
      }
    }
  }
`, X = (e) => /* @__PURE__ */ t(ut, { children: /* @__PURE__ */ t(
  Me,
  {
    className: "footer",
    dataCy: "drawer-footer",
    ...e,
    "data-analytics": D,
    "data-object": W,
    "data-type": ge
  },
  "footer"
) }), gt = "assets/card-actions-mfe/CardStatusTracker-Header.svg", mt = "assets/card-actions-mfe/technical-error.svg", ht = "assets/card-actions-mfe/no_replacement_request.svg", ft = "assets/card-actions-mfe/CardStatusTracker-Pending.png", Te = o.button`
  color: ${u.cyanBlue};
  cursor: pointer;
  font-weight: ${f.bold};
  line-height: ${B.large};
  font-size: ${E.root}px;
  border: none;
  background-color: transparent;
  padding: 0px;
`, Tt = "OUT FOR DELIVERY", Ee = "MMM d, Y", Et = ["IN TRANSIT"], ee = ["DELIVERED"], $ = [
  "CARD ORDERED",
  "PREPARING FOR SHIPMENT",
  "IN TRANSIT",
  "OUT FOR DELIVERY"
], Rt = (e, r = []) => {
  const n = $.findIndex(
    (i) => i === e
  );
  return $.map((i, a) => {
    const c = r.find(
      (m) => m.trackingStatus === i
    )?.eventDateTime, p = !Et.includes(i) && c ? le(c, Ee) : "", d = n > a, T = i === e;
    return {
      status: `stepper.${i}`,
      isCurrent: T,
      isCompleted: d,
      isFaded: !(d || T),
      date: p,
      isLast: a === $.length - 1
    };
  });
}, Ct = (e) => {
  if (!e.cardShipmentDate)
    return !0;
  const r = $?.includes(e.trackingStatus) || ee.includes(e.trackingStatus), n = e.trackingEvents?.filter(
    (i) => $.includes(i.trackingStatus) || ee.includes(i.trackingStatus)
  );
  return r && n?.length === e.trackingEvents?.length;
}, yt = (e) => e.trackingEvents?.find(
  (n) => n.trackingStatus === e.trackingStatus && $.includes(n.trackingStatus)
) !== void 0 || !e.trackingEvents?.length, St = (e = []) => e.filter(Ct).filter(yt).length !== e.length, xt = o.div`
  display: flex;
  flex-direction: row;
`, At = o.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 36px;
  max-width: 56px;
  max-height: 36px;
`, Dt = o.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;

  @media ${h.greaterThanSmall} {
    padding-left: ${s.small}px;
  }
`;
o.div`
  display: flex;
  align-items: center;
`;
const vt = o(Ke)`
  font-size: 14px;
  @media ${h.lessThanSmall} {
    font-size: 12px;
  }
`, bt = o.img`
  max-width: 100%;
  min-height: 1px;
  object-fit: contain;
`, _t = ({
  img: e,
  subtitle: r,
  alt: n,
  className: i,
  fallbackImage: a,
  ...c
}) => /* @__PURE__ */ l(xt, { className: i, ...c, children: [
  e && /* @__PURE__ */ t(At, { children: /* @__PURE__ */ t(bt, { alt: n, src: e }) }),
  /* @__PURE__ */ t(Dt, { children: /* @__PURE__ */ t(ze, { horizontal: "xsmall", left: "small", right: "xsmall", children: typeof r == "string" ? /* @__PURE__ */ t(vt, { children: r }) : r }) })
] }), te = {
  "CARD ORDERED": { backgroundColor: "#FFFAEB", textColor: "#8A6C00" },
  "OUT FOR DELIVERY": { backgroundColor: "#e7f6e3", textColor: "#2b5c1d" },
  default: {
    backgroundColor: "#e0f7fa",
    textColor: "#34657F"
  }
}, kt = o(Ue)`
  padding: 2px ${Number(s.small)}px;
  text-align: center;
  flex-shrink: 0;
`, It = ({
  cardStatus: e,
  children: r,
  dataCy: n
}) => {
  const i = e, { backgroundColor: a, textColor: c } = te[i] || te.default;
  return /* @__PURE__ */ t(
    kt,
    {
      backgroundColor: a,
      content: r,
      "data-cy": n,
      textColor: c
    }
  );
}, Re = o.div`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 10px 0px,
    rgba(0, 0, 0, 0.08) 0px 4px 5px 0px, rgba(0, 0, 0, 0.04) 0px 2px;
  padding: ${s.large}px;
  border-radius: ${s.small}px;
  width: 100%;
  box-sizing: border-box;
  @media ${h.lessThanSmall} {
    padding: ${s.base}px;
    padding-bottom: ${s.large}px;
  }
  display: flex;
  flex-direction: column;
  gap: ${s.base}px;
`, Ce = o.div`
  margin-left: -${s.large}px;
  margin-right: -${s.large}px;
  margin-top: -${s.large}px;
  background-color: ${Be.info.background};
  border-top-right-radius: ${s.small}px;
  border-top-left-radius: ${s.small}px;
  padding: ${s.small}px ${s.large}px;
  font-size: ${E.small}px;
  font-weight: ${f.bold};
  color: #244759;
  @media ${h.lessThanSmall} {
    margin-left: -${s.base}px;
    margin-right: -${s.base}px;
  }
`, $t = o.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  @media ${h.lessThanSmall} {
    align-items: flex-start;
  }
`, ye = o(Ge)`
  font-weight: ${f.semiBold};
  font-size: ${E.medium}px;
`, Ot = o.div`
  display: flex;
  justify-content: ${({ showActivateButton: e }) => e ? "space-between" : "flex-end"};
  align-items: center;
`, Lt = o.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: ${s.large}px;
  padding-bottom: 96px;
  height: 100%;
  width: 100%;
  gap: ${s.base}px;
`, Nt = o.span`
  margin-left: ${s.small}px;
  font-size: ${E.root}px;
  font-weight: ${f.bold};
  transition: transform 0.2s;
  transform: rotate(${(e) => e.open ? "180deg" : "0deg"});
`, Pt = o(pe)`
  margin: 0px;
  border: 0px;
  padding: 0px;
  background-color: white;
  padding-top: -2px;
  font-size: 14px;
  height: inherit;
  text-transform: none;
  &:hover {
    background: none;
  }

  &:active:after {
    transform: none;
    opacity: 0;
    transition: 0s;
  }
  @media ${h.lessThanSmall} {
    min-width: 30%;
    width: 30%;
  }
`, wt = o.span`
  @media ${h.lessThanSmall} {
    display: block;
  }
`, Mt = o.div`
  border-bottom: 1px solid ${u.lightGrey};
`, Bt = o(pe)`
  margin: 0px;
  height: 28px;
  padding: 4px ${s.large}px;
  text-transform: capitalize;
`, Ut = o.div`
  display: ${({ expand: e }) => e ? "" : "none"};
  overflow: ${({ expand: e }) => e ? "visible" : "hidden"};
  min-height: ${({ outForDelivery: e }) => e ? "698px" : "570px"};
  @media ${h.lessThanSmall} {
    min-height: ${({ outForDelivery: e }) => e ? "700px" : "550px"};
  }
`, Ft = o.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`, zt = o.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  gap: ${s.xlarge}px;
  padding: ${s.xxlarge}px 48px;
  @media ${h.lessThanSmall} {
    padding: ${s.xxlarge}px ${s.base}px;
    gap: ${s.large}px;
  }
`, Vt = o.img`
  margin: auto;
`, jt = o.h2`
  font-weight: ${f.bold};
  margin-top: ${s.xlarge}px;
  font-size: ${E.medium}px;
  margin: auto;
  color: ${u.black};
  line-height: 1.04;
  letter-spacing: 0;
`, Kt = o.p`
  font-weight: ${f.regular};
  font-size: ${E.root}px;
  line-height: ${B.larger};
  color: ${u.black};
  margin: auto;
  text-align: center;
  @media ${h.lessThanSmall} {
    width: 343px;
  }
`, re = o.span`
  color: ${u.cyanBlue};
  cursor: pointer;
  font-weight: ${f.bold};
  line-height: ${B.large};
  font-style: normal;
`, Gt = o.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 311px;

  @media ${h.lessThanSmall} {
    width: 100%;
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    80%,
    100% {
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
  }
`, Yt = o.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${({ last: e }) => e ? "0" : "66px"};
  position: relative;
  width: 100%;
`, Wt = (e, r, n) => e || n ? u.cyanBlue : r ? u.white : u.turquoiseLight, qt = (e, r) => e || r ? u.white : u.cyanBlue, Ht = o.div`
  width: ${s.large}px;
  height: ${s.large}px;
  border-radius: 50%;
  background: ${({ active: e, completed: r, reached: n }) => e ? u.cyanBlue : Wt(r, e, n)};
  color: ${({ completed: e, reached: r }) => qt(e, r)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${f.semiBold};
  font-size: 1rem;
`, Qt = o.div`
  animation: grow 1.5s infinite;
  @keyframes grow {
    0% {
      transform: scale(1);
    }
    40% {
      transform: scale(1.2);
    }
    80%,
    100% {
      transform: scale(1);
    }
  }
`, Jt = o.div`
  position: absolute;
  top: ${s.large}px;
  left: 26px;
  width: ${s.xsmall}px;
  height: ${({ last: e }) => e ? 0 : "79px"};
  background: ${({ reached: e }) => e ? "#34657F" : u.turquoiseLight};
  z-index: -1;
`, Xt = o.div`
  display: flex;
  flex-direction: column;
  margin-left: ${s.base}px;
`, Zt = o.div`
  font-size: 14px;
  font-weight: ${f.bold};
  color: ${({ faded: e }) => e ? "#B1B1B1" : "#222"};
`, er = o.div`
  font-size: ${E.small}px;
  font-weight: ${f.regular};
  color: ${u.doveGray};
`, tr = o.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: ${s.large}px;
  height: ${s.large}px;
  background: #34657f;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
  animation: pulse-animation 1.5s infinite;
`, rr = o.div`
  position: relative;
  padding-left: ${s.base}px;
`, ar = o.div`
  background: ${u.lightestGrey};
  position: absolute;
  z-index: -2;
  width: 100%;
  height: ${({ lastStep: e }) => e ? "200px" : "76px"};
  top: -20px;
  border-radius: ${s.small}px;
`, nr = o.div`
  padding-top: 5px;
  font-size: ${E.small}px;
  font-weight: ${f.regular};
  font-style: italic;
  padding-right: 36px;
`, or = (e) => e.isCurrent ? "active" : e.isCompleted ? "completed" : "faded", ir = ({ steps: e = [] }) => {
  const { t: r } = x(g), { handleChatOpen: n } = v(), { lostOrStolenMfeHandler: i } = S(k);
  return /* @__PURE__ */ t(Gt, { children: e.map((a) => /* @__PURE__ */ l(
    Yt,
    {
      active: a.isCurrent,
      completed: a.isCompleted,
      "data-cy": "card-status-tracker-step",
      last: a.isLast,
      children: [
        a.isCurrent && /* @__PURE__ */ t(ar, { lastStep: a.isLast }),
        /* @__PURE__ */ t(rr, { children: /* @__PURE__ */ t(
          Ht,
          {
            active: a.isCurrent,
            completed: a.isCompleted,
            "data-cy": `card-status-tracker-circle-${or(a)}`,
            reached: a.isCompleted,
            children: a.isCurrent && /* @__PURE__ */ l(Qt, { children: [
              /* @__PURE__ */ t(tr, {}),
              /* @__PURE__ */ t(ce, { color: "#fff", icon: Ve, size: "xs" })
            ] })
          }
        ) }),
        /* @__PURE__ */ l(Xt, { children: [
          /* @__PURE__ */ t(
            Zt,
            {
              "data-cy": "card-status-tracker-title",
              faded: a.isFaded,
              children: r(a.status)
            }
          ),
          !a.isFaded && /* @__PURE__ */ t(er, { "data-cy": "card-status-tracker-date", children: a.date }),
          a.isCurrent && a.isLast && /* @__PURE__ */ t(nr, { "data-cy": "card-status-tracker-final-step-content", children: /* @__PURE__ */ t(
            A,
            {
              components: {
                lostStolenButton: /* @__PURE__ */ t(
                  re,
                  {
                    "data-analytics": D,
                    "data-object": L,
                    "data-type": et,
                    role: "button",
                    tabIndex: 0,
                    onClick: i
                  }
                ),
                chatLink: /* @__PURE__ */ t(
                  re,
                  {
                    "data-analytics": D,
                    "data-object": L,
                    "data-type": tt,
                    role: "button",
                    tabIndex: 0,
                    onClick: n
                  }
                )
              },
              i18nKey: "stepper.lostStolenNote",
              ns: g,
              t: r
            }
          ) })
        ] }),
        /* @__PURE__ */ t(Jt, { last: a.isLast, reached: a.isCompleted })
      ]
    },
    a.status
  )) });
}, sr = o.div`
  border-bottom: 1px solid ${u.lightGrey};
  border-top: 1px solid ${u.lightGrey};
`, ae = o.h5`
  font-size: ${E.root}px;
  margin: 0px;
`, ne = o(de)`
  font-size: ${E.root}px;
`, cr = ({ card: e }) => {
  const { data: r } = he();
  return /* @__PURE__ */ l(Ye, { expand: !0, id: "collapse-card", children: [
    /* @__PURE__ */ t(_, { size: "large" }),
    /* @__PURE__ */ l(sr, { children: [
      /* @__PURE__ */ t(_, { size: "large" }),
      r && /* @__PURE__ */ l(N, { children: [
        /* @__PURE__ */ t(ae, { children: /* @__PURE__ */ t(A, { i18nKey: "stepper.deliveryAddress", ns: g }) }),
        /* @__PURE__ */ l(ne, { "data-cy": "card-status-tracker-address1", children: [
          r.profile.mailingAddress["cipher.addressLine1"],
          ",",
          r.profile.mailingAddress["cipher.addressLine2"]
        ] }),
        /* @__PURE__ */ l(ne, { "data-cy": "card-status-tracker-address2", children: [
          r.profile.mailingAddress["cipher.city"],
          ",",
          r.profile.mailingAddress["cipher.state"],
          ",",
          r.profile.mailingAddress["cipher.zipCode"]
        ] })
      ] }),
      /* @__PURE__ */ t(_, {}),
      /* @__PURE__ */ t(ae, { children: /* @__PURE__ */ t(
        A,
        {
          i18nKey: "stepper.deliveredBy",
          ns: g,
          values: { shipmentCarrier: e.shipmentCarrier }
        }
      ) }),
      /* @__PURE__ */ t(_, { size: "large" })
    ] }),
    /* @__PURE__ */ t(_, { size: "large" }),
    /* @__PURE__ */ t(
      ir,
      {
        steps: Rt(e.trackingStatus, e.trackingEvents)
      }
    )
  ] });
}, dr = ({ card: e, cardSequence: r }) => {
  const { t: n } = x(g);
  return /* @__PURE__ */ l(Re, { children: [
    /* @__PURE__ */ l(Ce, { "data-cy": `card-sequence-${r}`, children: [
      n("stepper.card"),
      " ",
      r
    ] }),
    /* @__PURE__ */ l(ye, { children: [
      n("stepper.estimatedDelivery"),
      /* @__PURE__ */ t("span", { "data-cy": `card-title-${r}`, children: n("error.pending") })
    ] }),
    /* @__PURE__ */ t(Ft, { "data-cy": `card-message-${r}`, children: n("error.message") })
  ] }, e["cipher.cardLast4"]);
}, lr = ({
  card: e,
  imgUrl: r,
  subtitle: n,
  cardLength: i,
  cardSequence: a
}) => {
  const [c, p] = j(!1), { t: d } = x(g), T = d(c ? "stepper.showLess" : "stepper.viewMore"), { trackingStatus: m, estimatedDeliveryDate: P } = e, w = m === Tt, R = w && c, { handleActivateCard: b } = v(), { triggerAnalyticsEvent: Z } = ue(), { data: De } = J();
  return O(() => {
    I[m] !== void 0 && c && Z({
      ...I[m],
      ...M(i)
    });
  }, [
    De,
    i,
    m,
    Z,
    c
  ]), e.estimatedDeliveryDate ? /* @__PURE__ */ l(Re, { children: [
    /* @__PURE__ */ l(Ce, { children: [
      d("stepper.card"),
      " ",
      a
    ] }),
    /* @__PURE__ */ l($t, { children: [
      /* @__PURE__ */ l(ye, { children: [
        d("stepper.estimatedDelivery"),
        /* @__PURE__ */ t(wt, { "data-cy": "card-status-tracker-delivery", children: le(
          P,
          Ee
        ) })
      ] }),
      /* @__PURE__ */ t(It, { cardStatus: m, dataCy: "card-status-tracker-chip", children: d(`chip.${m}`) })
    ] }),
    /* @__PURE__ */ t(_t, { alt: "", img: r, subtitle: n }),
    /* @__PURE__ */ t(Ut, { expand: c, outForDelivery: w, children: /* @__PURE__ */ t(cr, { card: e }) }),
    R && /* @__PURE__ */ l(N, { children: [
      /* @__PURE__ */ t(Mt, {}),
      /* @__PURE__ */ t(_, { size: "large" }),
      /* @__PURE__ */ t(de, { "data-cy": "activate-button-notification", children: d("stepper.readyToUse") }),
      /* @__PURE__ */ t(_, { size: "large" })
    ] }),
    /* @__PURE__ */ l(Ot, { showActivateButton: R, children: [
      R && /* @__PURE__ */ t(
        Bt,
        {
          buttonType: "secondary",
          "data-analytics": D,
          "data-cy": "activate-button",
          "data-object": W,
          "data-type": Ze,
          onClick: b,
          children: d("button.activateCard")
        }
      ),
      /* @__PURE__ */ l(
        Pt,
        {
          buttonType: "ghost",
          "data-analytics": D,
          "data-cy": "card-status-tracker-button",
          ...nt(c),
          onClick: () => {
            p(!c);
          },
          children: [
            T,
            /* @__PURE__ */ t(Nt, { open: c, children: /* @__PURE__ */ t(ce, { icon: je }) })
          ]
        }
      )
    ] })
  ] }, e["cipher.cardLast4"]) : /* @__PURE__ */ t(
    dr,
    {
      card: e,
      cardSequence: a
    },
    e["cipher.cardLast4"]
  );
}, pr = () => {
  const {
    hosts: { assets: e }
  } = me(), { t: r } = x(g), { handleChatOpen: n } = v(), { data: i } = Q(), { data: a } = J(), { triggerAnalyticsEvent: c } = ue();
  return O(() => {
    c({
      pageKind: C.CARD_STATUS_TRACKER,
      ...M(i?.cards.length),
      pageName: y.VIEW
    });
  }, []), /* @__PURE__ */ l(zt, { children: [
    /* @__PURE__ */ t(
      Vt,
      {
        alt: "",
        "data-cy": "card-status-tracker-image-name",
        src: `${e}${gt}`
      }
    ),
    /* @__PURE__ */ t(jt, { "data-cy": "card-status-tracker-header", children: /* @__PURE__ */ t(A, { i18nKey: "mfeTitle", ns: g, t: r }) }),
    /* @__PURE__ */ t(
      Kt,
      {
        "data-analytics": D,
        "data-cy": "card-status-tracker-description",
        "data-object": L,
        "data-type": K,
        children: /* @__PURE__ */ t(
          A,
          {
            components: {
              chatLink: /* @__PURE__ */ t(
                Te,
                {
                  "data-analytics": D,
                  "data-object": L,
                  "data-type": K,
                  onClick: n
                }
              )
            },
            i18nKey: "header.subheading"
          }
        )
      }
    ),
    /* @__PURE__ */ t(Lt, { children: i?.cards.map((p, d) => /* @__PURE__ */ t(
      lr,
      {
        card: p,
        cardLength: i.cards.length,
        cardSequence: d + 1,
        imgUrl: a?.card.cardArtURL || "",
        subtitle: a?.product.displayName || ""
      },
      p["cipher.cardLast4"]
    )) })
  ] });
}, ur = () => {
  const { handleModalClose: e } = v(), { t: r } = x(g), n = {
    dataCy: "cst-drawer-footer",
    handlePrimaryButton: e,
    primaryText: r("button.closeButtonText"),
    dataPrimaryAnalytics: "click",
    dataPrimaryObject: W,
    dataPrimaryType: ge
  };
  return /* @__PURE__ */ l(N, { children: [
    /* @__PURE__ */ t(pr, {}),
    /* @__PURE__ */ t(X, { ...n })
  ] });
}, oe = "api_failure_error", Se = "no_card_error", xe = "card_request_processing_error", V = {
  [Se]: {
    errorTitle: "noReplacementRequest.errorTitle",
    errorSecondaryDescription: "noReplacementRequest.errorSecondaryDescription",
    errorDescription: "noReplacementRequest.errorDescription",
    imageSrc: ht
  },
  [xe]: {
    errorTitle: "noCardUpdate.errorTitle",
    errorDescription: "noCardUpdate.errorDescription",
    imageSrc: ft
  },
  default: {
    errorTitle: "apiError.errorTitle",
    errorDescription: "apiError.errorDescription",
    imageSrc: mt
  }
}, gr = (e) => e && V[e] ? V[e] : V.default, mr = o.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  gap: ${s.large}px;
  padding: ${s.xxlarge}px 48px;
  @media ${h.lessThanSmall} {
    padding: ${s.xxlarge}px ${s.base}px;
  }
`, hr = o.img`
  margin: auto;
  margin-bottom: ${s.small}px;
  @media ${h.lessThanSmall} {
    margin-top: 0;
  }
`, fr = o.h2`
  font-weight: ${f.bold};
  font-size: ${E.medium}px;
  margin: auto;
  color: ${u.black};
  line-height: 1.4;
  letter-spacing: 0;
  text-align: center;
`, ie = o.p`
  font-weight: ${f.regular};
  font-size: ${E.root}px;
  line-height: ${B.larger};
  color: ${u.black};
  margin: auto;
  text-align: center;
`, Tr = ({
  img: e,
  title: r,
  description: n,
  secondaryDescription: i
}) => {
  const {
    hosts: { assets: a }
  } = me(), { t: c } = x(g), { handleChatOpen: p } = v();
  return /* @__PURE__ */ l(mr, { children: [
    /* @__PURE__ */ t(
      hr,
      {
        alt: "",
        "data-cy": "card-status-tracker-error-image",
        src: `${a}${e}`
      }
    ),
    /* @__PURE__ */ t(fr, { "data-cy": "card-status-tracker-error-header", children: /* @__PURE__ */ t(A, { i18nKey: r, ns: g, t: c }) }),
    i && /* @__PURE__ */ t(ie, { "data-cy": "card-status-tracker-error-sec-description", children: /* @__PURE__ */ t(A, { i18nKey: i }) }),
    /* @__PURE__ */ t(ie, { "data-cy": "card-status-tracker-error-description", children: /* @__PURE__ */ t(
      A,
      {
        components: {
          chatLink: /* @__PURE__ */ t(
            Te,
            {
              "data-analytics": D,
              "data-object": L,
              "data-type": K,
              onClick: p
            }
          )
        },
        i18nKey: n
      }
    ) })
  ] });
}, Er = () => {
  const {
    handleModalClose: e,
    metaData: { errorType: r }
  } = v(), { t: n } = x(g), { errorTitle: i, errorDescription: a, errorSecondaryDescription: c, imageSrc: p } = gr(r), d = {
    dataCy: "cst-drawer-footer",
    handlePrimaryButton: e,
    primaryText: n("button.closeButtonText")
  };
  return /* @__PURE__ */ l(N, { children: [
    /* @__PURE__ */ t(
      Tr,
      {
        description: a,
        img: p,
        secondaryDescription: c,
        title: i
      }
    ),
    /* @__PURE__ */ t(X, { ...d })
  ] });
}, Rr = o.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${s.xxlarge}px;
`, Ae = () => /* @__PURE__ */ t(Rr, { children: /* @__PURE__ */ t(Fe, { size: 7 }) }), Cr = () => {
  const { isModalOpen: e, transition: r, handleModalClose: n } = v(), { t: i } = x(), {
    data: a,
    isError: c,
    refetch: p
  } = Q(), { isLoading: d } = J(), { isLoading: T } = he();
  if (O(() => {
    p();
  }, [p]), O(() => {
    if (c) {
      r("error", { errorType: oe });
      return;
    }
    if (!(d || T || !a || !Array.isArray(a.cards))) {
      if (a.cards.length === 0) {
        r("error", { errorType: Se });
        return;
      }
      if (a.cards.length === 1 && a.cards[0].estimatedDeliveryDate === "") {
        r("error", { errorType: xe });
        return;
      }
      if (St(a.cards)) {
        r("error", { errorType: oe });
        return;
      }
      r("cardStatusTracker");
    }
  }, [
    d,
    T,
    c,
    a,
    r
  ]), !e)
    return /* @__PURE__ */ t("div", {});
  const m = {
    dataCy: "cst-drawer-footer",
    handlePrimaryButton: n,
    primaryText: i("button.closeButtonText")
  };
  return /* @__PURE__ */ l(N, { children: [
    /* @__PURE__ */ t(Ae, {}),
    /* @__PURE__ */ t(X, { ...m })
  ] });
}, yr = {
  cardStatusTracker: ur,
  error: Er,
  initializing: Cr
}, Sr = ({
  containerId: e,
  selectedAccountId: r
}) => {
  const { t: n } = x(), { activeScreen: i, isModalOpen: a, handleModalClose: c, transition: p } = v(), d = i && yr[i];
  return O(() => {
    a && i !== "initializing" && p("initializing");
  }, [a]), /* @__PURE__ */ t(
    Pe,
    {
      ariaLabel: n("mfeTitle"),
      containerId: e,
      "data-cy": "card-status-tracker-modal",
      escapeModalHandler: c,
      header: /* @__PURE__ */ t(
        we,
        {
          closeModal: c,
          content: n("mfeTitle"),
          "data-cy": "card-status-tracker-drawer-name",
          dataType: Qe
        }
      ),
      id: `card-status-tracker-modal-${r}`,
      isOpen: a,
      children: d ? /* @__PURE__ */ t(d, {}) : /* @__PURE__ */ t(Ae, {})
    }
  );
}, Wr = ({
  closeModal: e,
  isModalOpen: r,
  containerId: n,
  mfeConfig: i,
  selectedAccountId: a,
  triggerAnalyticsEvent: c,
  lostOrStolenMfeHandler: p,
  ...d
}) => {
  O(() => {
    G.changeLanguage(i.lang);
  }, [i.lang]);
  const T = se(
    () => ({
      selectedAccountId: a,
      triggerAnalyticsEvent: c,
      lostOrStolenMfeHandler: p
    }),
    [a, c, p]
  );
  return /* @__PURE__ */ t(be, { i18n: G, children: /* @__PURE__ */ t(k.Provider, { value: T, children: /* @__PURE__ */ t(ot, { value: i, children: /* @__PURE__ */ l(
    ct,
    {
      handleModalClose: e,
      isModalOpen: r,
      children: [
        /* @__PURE__ */ t(
          "input",
          {
            id: "Card_Status_Tracker_build_version",
            type: "hidden",
            value: We.BuildVersion
          }
        ),
        /* @__PURE__ */ t(
          Sr,
          {
            containerId: n,
            selectedAccountId: a,
            ...d
          }
        )
      ]
    }
  ) }) }) });
};
export {
  Wr as default
};
//# sourceMappingURL=index.js.map
